<div class="p-16">
    <p class="pb-4">Here’s the overview:</p>
    <div *ngFor="let item of data" class="item">
        <div [ngStyle]="{ 'background-color': item.LeaveType === 'vacation' ? '#FF4A60' : ' #4A72FF' }"
            class="leave-type-box"></div>
        <span class="text-bold">{{item.AssignmentDate | date: 'dd.MM.yyyy'}}&nbsp;-&nbsp;</span>
        <span *ngIf="item.ActionStatus === 'accepted'" class="item">
            <mat-icon style="color: green">check_box</mat-icon>
            <span>{{ item.isAssigned ? 'Assigned' : 'Approved' }}</span>
        </span>
        <span *ngIf="item.ActionStatus === 'rejected'" class="item">
            <mat-icon style="color: red;">close</mat-icon>
            <span>&nbsp;Rejected</span>
        </span>
        <span *ngIf="item.ActionStatus === 'pending'" class="item">
            <!-- <mat-icon class="triangle-icon">priority_high</mat-icon> -->
             <div class="triangle-icon">
                 <mat-icon>warning</mat-icon>
             </div>
            <span>&nbsp;Pending</span>
        </span>
    </div>
    <p class="pt-4">Check your <span class="text-bold">Schedule</span> for more details.</p>
</div>
